import React, { useState, useEffect } from 'react';
import desktopImage from "../../assets/staff/0061-Careisgold.jpg";
import headerImageMobile from "../../assets/staff/0046-Careisgold-Copia.jpg";
import People from '../../components/People';
import { Helmet } from 'react-helmet';
import logo from '../../assets/oroPrestige/logo-trasp.webp';
import Static from '../../components/Static';
import AOS from 'aos';
import 'aos/dist/aos.css';


function Staff() {
  const [headerImage, setHeaderImage] = useState(null);
  const [loadingActive, setLoadingActive] = useState(true);


  const handleLinkClick = (active) => {

    const loadingOverlay = document.getElementById('loading-overlay');

    if (active) {
      loadingOverlay.classList.add('active');
    } else {
      loadingOverlay.classList.remove('active');
      setLoadingActive(false);
    }

  };

  useEffect(() => {
    if (headerImage === null) {
      handleLinkClick(true);
    } else {
      handleLinkClick(false);
    }

    const handleResize = () => {
      if (window.innerWidth > 800) {
        setHeaderImage(desktopImage)
      } else {
        setHeaderImage(headerImageMobile)
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [headerImage]);


  // togliere aos transition per mini-screen
  function initAOS() {
    AOS.init({
      disable: window.innerWidth <= 320 && window.innerHeight <= 256
    });
  }

  initAOS();

  window.addEventListener("resize", () => {
    AOS.refreshHard();
  });

  const description = 
  <div className='w-[70%] xl:w-full'>
    <p className='italic flex text-wrap w-full'>
      “Se ho avuto successo è perché mi sono sempre circondato di persone migliori di me”
    </p>
    <span className="block mt-2 text-right text-sm w-full" >Claudio Boso, Presidente di Careisgold S.p.A.</span>
  </div>

  return (
    <>
      <Helmet>
        <title>Team Careisgold: Esperti in Investimenti Oro al Tuo Servizio</title>
        <meta name="description" content="Conosci il team di professionisti Careisgold. Esperti oro fisico da investimento, risparmio e customer care pronti a guidarti nelle tue scelte d'investimento con competenza e dedizione." />
        <meta name="keywords" content="team Careisgold, esperti oro, professionisti risparmio, customer care oro" />
        <meta property="og:title" content="Team Careisgold: Esperti in Investimenti Oro al Tuo Servizio" />
        <meta property="og:description" content="Conosci il team di professionisti Careisgold. Esperti oro fisico da investimento, risparmio e customer care pronti a guidarti nelle tue scelte d'investimento con competenza e dedizione." />
        <meta property="og:image" content={headerImage} />
        <meta property="og:url" content="https://www.careisgold.it/staff/" />
        <meta property="og:type" content="page" />
        <link rel="canonical" href="https://www.careisgold.it/staff/" />
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Team Careisgold: Esperti in Investimenti Oro al Tuo Servizio",
          "url": "https://www.careisgold.it/staff/",
          "description": "Conosci il team di professionisti Careisgold. Esperti oro fisico da investimento, risparmio e customer care pronti a guidarti nelle tue scelte d'investimento con competenza e dedizione.",
          "inLanguage": "it",
          "primaryImageOfPage": {
            "@type": "ImageObject",
            "url": "https://www.careisgold.it${headerImage}"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Careisgold SpA",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.careisgold.it${logo}"
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Via Monte Baldo 14/D",
              "addressLocality": "Villafranca di Verona",
              "addressRegion": "Veneto",
              "postalCode": "37069",
              "addressCountry": "IT"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+39 045 8213155",
              "contactType": "Customer Service"
            },
            "sameAs": [
              "https://www.facebook.com/careisgoldspa",
              "https://www.instagram.com/careisgoldspa",
              "https://www.linkedin.com/company/careisgold-spa"
            ]
          }
        }
      `}
        </script>
      </Helmet>
      {!loadingActive &&
        <>
  
          <Static
          logoTransp=''
          headerImage={headerImage}
          title={`LE GRANDI IMPRESE NASCONO DAI MIGLIORI TEAM`}
          description={description}
          arrow
          />
          <People />

        </>
      }
    </>
  )
}

export default Staff